import React, { lazy, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  CBadge,
  CButton,
  CButtonGroup,
  CCard,
  CCardBody,
  CCardFooter,
  CCardHeader,
  CCol,
  CProgress,
  CRow,
  CImg,
  CCallout,
  CCardText,
  CCardImg,
} from 'compat/coreui'
import CIcon from 'compat/coreui-icon'
import axios from 'axios';
import moment from 'moment';
import MainChartExample from '../charts/MainChartExample.js'
import Visitors from '../charts/Visitors.js'

import WidgetsDropdown from '../widgets/WidgetsDropdown.js';
import WidgetsBrand from '../widgets/WidgetsBrand.js';
import OrderChildWithPre from '../OrderChildWithPre/OrderChildWithPre.js';

const PreOrder = () => {
  const history = useNavigate()
  const [analyticsData, setAnalyticsData] = useState([])
  const [response, setResponse] = useState({})
  const [totalUsers, setTotalUsers] = useState(0)
  const [totalReviews, setTotalReviews] = useState(0)
  const [totalFollowers, setTotalFollowers] = useState(0)
  const [totalVisitors, setTotalVisitors] = useState(0)
  const [activeFilter, setActiveFilter] = useState("Year")
  const [totalPreOrdersPending, setTotalPreOrdersPending] = useState(0)
  const token = localStorage.getItem('token');

  useEffect(() => {
    getAnalyticsData();
  }, [])

  const getAnalyticsData = () => {
    axios({
      url: `${process.env.REACT_APP_APP_API_URL}/api/dashboard`,
      method: 'GET',
      headers: {
        'Authorization': 'Bearer ' + token
      }
    }).then(response => {
      if (response.data.status) {
        setAnalyticsData(response.data.visitors.sort((a, b) => {
          if (b._id > a._id) return -1
          if (b._id < a._id) return 1
          if (b._id === a._id) return 0
        }).map(a => {
          a._id = moment(a._id).format('MM/DD/YY')
          return a
        }));
        setTotalVisitors(response.data.visitors.length);
        setTotalUsers(response.data.totalUsers);
        setTotalReviews(response.data.totaReviews);
        setTotalFollowers(response.data.followerCount);
        setTotalPreOrdersPending(response.data.preOrderCount);
        // setAnalyticsData(response.data);
      }
    }).catch(console.log)
  }
  const changeFilter = (e) => {
    console.log("---SSS", e);
    setActiveFilter(e);
  }
  return (
    <>
      <CCard>
        <CCardBody>
          <CRow>
            <CCol sm="5">
              <h2 className="card-title pb-3">Recent Visitors</h2>
              <div className="small text-muted">November 2017</div>
            </CCol>
            <CCol sm="7" className="d-none d-md-block">
              <CButton color="primary" className="float-right">
                <CIcon name="cil-cloud-download" />
              </CButton>
              <CButtonGroup className="float-right mr-3">
                {
                  ['Day', 'Month', 'Year'].map(value => (
                    <CButton
                      color="outline-secondary"
                      key={value}
                      className="mx-0"
                      active={value === activeFilter}
                      onClick={(e) => changeFilter(value)}
                    >
                      {value}
                    </CButton>
                  ))
                }
              </CButtonGroup>
            </CCol>
          </CRow>
          {(analyticsData && analyticsData.length > 0) ? <Visitors style={{ height: '300px', marginTop: '40px' }} analyticsData={analyticsData} /> : null}
        </CCardBody>
        <CCardFooter>
          <h2 className="card-title pb-3">Business Insights</h2>
          <CRow className="text-center">
            <CCol md sm="12" className="mb-sm-2 mb-0">
              <div className="text-muted">30 DAY VISITORS</div>
              <strong>{totalVisitors} Users ({((totalVisitors * 100) / totalUsers).toFixed(2)}%)</strong>
              <CProgress
                className="progress-xs mt-2"
                precision={1}
                color="success"
                value={40}
              />
            </CCol>
            <CCol md sm="12" className="mb-sm-2 mb-0 d-md-down-none">
              <div className="text-muted">New Visitors</div>
              <strong>{totalVisitors} ({((totalVisitors * 100) / totalUsers).toFixed(2)}%)</strong>
              <CProgress
                className="progress-xs mt-2"
                precision={1}
                color="info"
                value={40}
              />
            </CCol>
            <CCol md sm="12" className="mb-sm-2 mb-0">
              <div className="text-muted">Pre Orders</div>
              <strong>{totalPreOrdersPending}</strong>
              <CProgress
                className="progress-xs mt-2"
                precision={1}
                color="warning"
                value={40}
              />
            </CCol>
            <CCol md sm="12" className="mb-sm-2 mb-0">
              <div className="text-muted">Followers</div>
              <strong>{totalFollowers} ({((totalFollowers * 100) / totalUsers).toFixed(2)}%)</strong>
              <CProgress
                className="progress-xs mt-2"
                precision={1}
                color="danger"
                value={40}
              />
            </CCol>
            <CCol md sm="12" className="mb-sm-2 mb-0 d-md-down-none">
              <div className="text-muted">Reviews</div>
              <strong>{totalReviews}</strong>
              <CProgress
                className="progress-xs mt-2"
                precision={1}
                value={40}
              />
            </CCol>
          </CRow>
        </CCardFooter>
      </CCard>
      <OrderChildWithPre></OrderChildWithPre>

      <CRow className="text-center pre-order-cards">
        <CCol sm={12} lg={4}>
          <CCard>
            <CCardHeader>
              Menu & Products
            </CCardHeader>
            <CCardBody className="text-center" style={{ padding: "20px" }}>
              <ul className="menu-list">
                <li>
                  <CIcon name="cil-list" size="2xl" />
                  <CCardText>Update Your Menu</CCardText>
                </li>
                <li>
                  <CIcon name="cil-list" size="2xl" />
                  <CCardText>Pre order </CCardText>
                </li>
                <li>
                  <CIcon name="cil-list" size="2xl" />
                  <CCardText>Pre order </CCardText>
                </li>
                <li>
                  <CIcon name="cil-list" size="2xl" />
                  <CCardText>Pre order </CCardText>
                </li>
              </ul>
            </CCardBody>
          </CCard>
        </CCol>
        <CCol sm={12} lg={4}>
          <CCard>
            <CCardHeader>
              Specials & Deals
            </CCardHeader>
            <CCardBody className="text-center" style={{ padding: "0px" }}>
              <CCol >
                <CCardBody>
                  <CRow>
                    <CImg style={{ maxHeight: "30px" }} src="/images/p-tag.png" />
                    <p style={{ marginTop: "0px" }}>Add your daily deals &amp; specials to attract the bargain hunters in your community!</p>
                  </CRow>
                  <span>1 CREDIT</span>
                </CCardBody>
              </CCol>
            </CCardBody>
          </CCard>
        </CCol>
        <CCol sm={12} lg={4}>
          <CCard>
            <CCardHeader>
              Billing
            </CCardHeader>
            <CCardBody className="text-center">
              <CCol >
                <CCardBody>
                  {/* <CImg src="/images/p-tag.png" /> */}
                  <p>Package:</p>
                  <span>Claimed Listing $0 /mo</span>
                  <CButton style={{ marginBottom: "10px" }} color="success" className="text-white p-3 mt-2">UPGRADE YOUR LISTING</CButton>
                </CCardBody>
              </CCol>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
      <CRow className="text-center pre-order-cards">
        <CCol sm={12} lg={4}>
          <CCard>
            <CCardHeader>
              Online Pre-Ordering
            </CCardHeader>
            <CCardBody className="text-center" style={{ padding: "20px" }}>
              <p>Pre-ordering not available with your current package selection</p>
              <CButton style={{ marginBottom: "10px" }} color="success" className="text-white p-3 mt-2" onClick={() => { history('/dashboard/upgrade') }}>UPGRADE YOUR LISTING</CButton>
            </CCardBody>
          </CCard>
        </CCol>

        <CCol sm={12} lg={4}>
          <CCard>
            <CCardHeader>
              Account Representative
            </CCardHeader>
            <CCardBody className="text-center" style={{ padding: "20px" }}>
              <p>Questions about your account? Contact us!</p>
              <CButton style={{ marginBottom: "10px" }} color="success" className="text-white p-3 mt-2" onClick={() => {history('/contact')}}>Contact Us</CButton>
            </CCardBody>
          </CCard>
        </CCol>

        <CCol sm={12} lg={4}>
          <CCard>
            <CCardHeader>
              Recent Articles
            </CCardHeader>
            <CCardBody className="text-center" style={{ padding: "20px" }}>
              <ul>
                <li className="preorder_articles"><a href="#" >5-successful-tips-for-increasing-your-dispensarys-local-search-ranking</a></li>
                <li className="preorder_articles"><a href="#" >embedding-your-jointplug-marijuana-menu-on-your-wordpress-site</a></li>
                <li className="preorder_articles"><a href="#" >introducing-integrated-online-ordering-for-dispensary-websites-from-wheres-weed</a></li>
                <li className="preorder_articles"><a href="#" >online-ordering-how-order-processing-work</a></li>
              </ul>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
      <CRow className="text-center pre-order-cards">
        <CCol sm={12} lg={4}>
          <CCard >
            <CCardHeader>
              Helpful Articles
            </CCardHeader>
            <CCardBody className="helpful-article">
              <ul>
                <li className="preorder_articles"><a href="#" >Step 1: Setting up your profile</a></li>
                <li className="preorder_articles"><a href="#" >Adding your products</a></li>
                <li className="preorder_articles"><a href="#" >How to setup Online Ordering</a></li>
                <li className="preorder_articles"><a href="#" >How to sync your point-of-sale system</a></li>
              </ul>
            </CCardBody>
          </CCard>
        </CCol>
        <CCol sm={12} lg={4}>
          <CCard >
            <CCardHeader>
              Website Widgets
            </CCardHeader>
            <CCardBody className="helpful-article">
              <span><CCardImg src="/images/widget_header.jpg" /></span>
              <span>
                <p>Take the best parts of Where's Weed and embed them directly on your own website.</p>
                <CButton color="success" className="text-white p-3">View Widgets</CButton>
              </span>
            </CCardBody>
          </CCard>
        </CCol>
        <CCol sm={12} lg={4}>
          <CCard className="attract-customer">
            <CCardHeader>
              Attract more customers
            </CCardHeader>
            <CCardBody className="text-center" style={{ padding: "20px" }}>
              <p>Businesses that advertise with Where's Weed see 4-10x as many customers. Find out for yourself by taking our free 7-day trial.</p>
              <CButton style={{ marginBottom: "10px" }} color="warning" className="text-white p-3 mt-2" onClick={() => { history('/dashboard/upgrade') }}>START YOUR TRIAL</CButton>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </>
  )
}

export default PreOrder; 
